import React, { useContext, useState } from 'react';
import 'twin.macro';
import { reportComment } from 'services/comments';
import { UserContext } from '../context';
import { formatDate, formatTime, openWindow, encodeProfileUrl } from '../../lib/helpers';
import { Title, Paragraph, Small } from '../text';
import { LoginForm } from '../form';
import { Icon } from '../icon';
import { ExclamationIcon, BabyIcon } from 'icons';
import { gaEvent } from 'services/ga';
import { userLogout } from 'services/user';
import { settings } from '../../settings/';

export const Separator = () => (
  <Small Type='span' tw='mx-1'>
    |
  </Small>
);

export const LoggedInUser = ({ children, openComments, subComment, hideForm }) => {
  const { user } = useContext(UserContext);
  return (
    <>
      {!openComments && <Paragraph>Comments zijn gesloten</Paragraph>}
      {openComments && (
        <>
          {user && (
            <div>
              {!subComment && (
                <Paragraph>
                  Ingelogd als <strong>{user.name}</strong>
                  <br />
                  Klik{' '}
                  <strong
                    tw='cursor-pointer text-brand'
                    onClick={() => {
                      userLogout();
                    }}
                  >
                    hier
                  </strong>{' '}
                  om uit te loggen.
                </Paragraph>
              )}
              {children}
            </div>
          )}
          {!user && !hideForm && (
            <>
              <Paragraph tw='mb-4'>
                Je bent <strong>niet</strong> ingelogd
                <br />
                Je moet ingelogd zijn om te kunnen reaguren
              </Paragraph>
              <LoginForm />
            </>
          )}
        </>
      )}
    </>
  );
};

export const CommentListHeader = ({ children, ...restProps }) => (
  <div>
    <Title Type='h3' text={'REAGUREN'} tw='mb-2' />
    <LoggedInUser {...restProps}>{children}</LoggedInUser>
  </div>
);

export const Author = ({ author, authorId, newbie }) => {
  const { user } = useContext(UserContext);
  const ripUser = !author || author.username === 'Rest in privacy';

  return (
    <div tw='min-w-max'>
      <div tw='flex justify-center items-center'>
        {ripUser && (
          <>
            <span tw='mr-1 text-xs'>&#128128;</span>
            <Small bold text='Rest in Privacy' tw='line-through' />
          </>
        )}
        {author && !ripUser && (
          <>
            {newbie && <Icon Type={BabyIcon} size='small' tw='mr-1' />}
            {user && user.moderate && (
              <div
                onClick={() => openWindow(`${settings.ADMIN_HOST_URL}/moderation/edit/${authorId}`)}
                tw='cursor-pointer'
              >
                <Small bold text={author.username} />
              </div>
            )}
            {!(user && user.moderate) && (
              <a
                href={`/profiel/${encodeProfileUrl(author.username)}`}
                target='_blank'
                rel='noreferrer'
              >
                <Small bold text={author.username} />
              </a>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export const Date = ({ date }) => (
  <div tw='flex justify-center items-center md:ml-0 flex-shrink-0 flex-nowrap'>
    <Small>
      {formatDate(date, true)}
      <Separator />
      {formatTime(date)}
    </Small>
  </div>
);

export const Reply = ({ comment, setSubCommentForm }) => {
  const { id } = comment;

  return (
    <>
      <Separator />
      <Small
        tw='text-brand cursor-pointer'
        onClick={() => {
          setSubCommentForm({ id, active: true });
        }}
      >
        reageer
      </Small>
    </>
  );
};

export const ReportComment = ({ commentId }) => {
  const [reportGiven, setReportGiven] = useState(false);
  return (
    <Small tw='flex items-center'>
      <Separator />
      <Icon
        Type={ExclamationIcon}
        onClick={
          !reportGiven
            ? () => {
                alert('Bedankt voor het melden.');
                gaEvent('dmp_comment', 'nsb');
                setReportGiven(true);
                reportComment(commentId);
              }
            : null
        }
        color={reportGiven ? 'danger' : 'icons'}
        tw='cursor-pointer'
        size='small'
      />
    </Small>
  );
};
